import { render, staticRenderFns } from "./homeAsideMenu.vue?vue&type=template&id=37dd4abc&"
import script from "./homeAsideMenu.vue?vue&type=script&lang=js&"
export * from "./homeAsideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/homeAsideMenu.vue"
export default component.exports